import clsx from 'clsx';

import styles from './PriceDisplay.module.scss';

interface PriceProps {
  price: string;
  info?: string | null;
  className?: string;
}

export const PriceDisplay = ({ price, info, className }: PriceProps) => {
  const [dollars, cents] = String(price).split('.');

  return (
    <div className={clsx(styles.block, className)} data-ui="price-display">
      <span className={styles.price}>${dollars}</span>
      <div className={styles.details}>
        {cents && <span className={styles.cents}>.{cents}</span>}
        {info && <span className={styles.info}>{info}</span>}
      </div>
    </div>
  );
};
